export default function SEOContent() {
  const faqs = [
    {
      q: '韩国漫画和日本漫画有什么区别？',
      a: '韩国漫画（Webtoon）通常采用纵向滚动阅读方式，专为移动端优化，内容更新频率高，题材更加多元化。日本漫画则以翻页式阅读为主，画面风格和叙事节奏各有特色。韩漫大全提供正版高清韩国漫画，让您体验流畅的纵向阅读。',
    },
    {
      q: '韩漫大全的漫画资源是否正版？',
      a: '是的，韩漫大全所有漫画内容均来自正版授权渠道，确保每位读者都能享受到高清画质的正版漫画阅读体验。我们与多家韩国漫画平台合作，为中文读者提供最新最全的韩国漫画资源。',
    },
    {
      q: '如何免费阅读韩国漫画？',
      a: '您可以直接在韩漫大全网站上免费浏览所有漫画。无需注册登录，点击即可阅读。我们每日更新资源，提供热血动作、奇幻冒险、浪漫恋爱、悬疑惊悚等多种题材供您选择。',
    },
    {
      q: '网站多久更新一次漫画？',
      a: '韩漫大全坚持每日更新，确保读者能第一时间看到最新的韩国漫画章节。我们拥有专业的更新团队，与韩国漫画平台同步更新，让您不会错过任何精彩内容。',
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="mb-12 text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">为什么选择韩漫大全？</h2>
          <p className="text-sm text-foreground-500 max-w-2xl mx-auto">
            我们致力于为中文读者提供最优质的韩国漫画阅读体验，正版授权、高清画质、每日更新
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-14">
          {[
            { icon: 'ri-shield-check-line', title: '正版授权', desc: '所有漫画内容均获得正版授权，品质有保障' },
            { icon: 'ri-4k-line', title: '高清画质', desc: '提供超高清漫画资源，带来视觉盛宴' },
            { icon: 'ri-refresh-line', title: '每日更新', desc: '与韩国同步更新，精彩内容每日不断' },
          ].map(feature => (
            <div key={feature.title} className="text-center p-6">
              <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-primary-100 flex items-center justify-center">
                <i className={`${feature.icon} text-primary-500 text-2xl`} />
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-500">{feature.desc}</p>
            </div>
          ))}
        </div>

        <div>
          <h3 className="text-xl font-heading font-bold text-foreground-900 mb-6 text-center">常见问题</h3>
          <div className="space-y-4">
            {faqs.map((faq, i) => (
              <details key={i} className="group bg-background-100 rounded-xl border border-background-200/70">
                <summary className="flex items-center justify-between px-6 py-4 cursor-pointer text-sm font-medium text-foreground-900">
                  {faq.q}
                  <span className="ml-2 transition-transform duration-200 group-open:rotate-180">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-arrow-down-s-line text-foreground-500" />
                    </div>
                  </span>
                </summary>
                <div className="px-6 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}